import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import CollapsibleSidebar from './CollapsibleSidebar';

const AdminSidebar = ({ activeTab, setActiveTab }) => {
  const { palette } = useTheme();
  const [hoveredItem, setHoveredItem] = useState(null);

  // Art Deco gold for V12
  const artDecoGold = '#D4AF37';

  const menuItems = [
    { id: 'users', label: 'Users' },
    { id: 'v12', label: 'V12 Diagnostic', isV12: true },
    { id: 'courses', label: 'Courses' },
    { id: 'pacing', label: 'Course Pacing' },
    { id: 'widgets', label: 'Widgets' },
    { id: 'persistent_widgets', label: 'Persistent Widgets' },
    { id: 'glossary', label: 'Glossary' },
    { id: 'metrics', label: 'Metrics' },
    { id: 'site_management', label: 'Site Management' },
  ];

  return (
    <CollapsibleSidebar itemCount={menuItems.length}>
      <View style={styles.sidebarList}>
        {menuItems.map((item) => {
          const isActive = activeTab === item.id;
          const isHovered = hoveredItem === item.id;
          const isV12 = item.isV12;
          
          return (
            <TouchableOpacity
              key={item.id}
              style={[
                styles.sidebarItem,
                isActive && styles.activeItem,
                isHovered && !isActive && Platform.OS === 'web' && styles.hoveredItem,
                isV12 && styles.v12SidebarItem,
              ]}
              onPress={() => setActiveTab(item.id)}
              onMouseEnter={Platform.OS === 'web' ? () => setHoveredItem(item.id) : undefined}
              onMouseLeave={Platform.OS === 'web' ? () => setHoveredItem(null) : undefined}
            >
              {isV12 && (
                <View style={[styles.v12Badge, { backgroundColor: artDecoGold }]}>
                  <Text style={styles.v12BadgeText}>V12</Text>
                </View>
              )}
              <Text
                style={[
                  styles.sidebarText,
                  isActive && styles.sidebarTextActive,
                  isV12 && { marginLeft: 8 },
                ]}
              >
                {isV12 ? 'Diagnostic' : item.label}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </CollapsibleSidebar>
  );
};

const styles = StyleSheet.create({
  sidebarList: {
    gap: 8,
    paddingHorizontal: 16,
  },
  sidebarItem: {
    alignSelf: 'stretch',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    minHeight: 40,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    ...Platform.select({
      web: {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      },
    }),
  },
  activeItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    ...Platform.select({
      web: {
        boxShadow: '2px 3px 0px rgba(0,0,0,0.8)',
      },
    }),
  },
  hoveredItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  v12SidebarItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  v12Badge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  v12BadgeText: {
    fontSize: 9,
    fontFamily: 'Archivo',
    fontWeight: '900',
    color: '#1A1A1A',
    letterSpacing: 1,
  },
  sidebarText: {
    flex: 1,
    fontSize: 15,
    fontFamily: 'Public Sans',
    fontWeight: '500',
    color: 'white',
    ...Platform.select({
      web: {
        textShadow: '1px 1px 0px rgba(0,0,0,0.8)',
      },
    }),
  },
  sidebarTextActive: {
    fontWeight: '700',
    color: '#000000',
    ...Platform.select({
      web: {
        textShadow: 'none',
      },
    }),
  },
});

export default AdminSidebar;

